import axios, { AxiosError } from "axios";
import { LOCATOR_URL } from "../map/Map.constants";
import { IMapPoint } from "../map/Map.types";

export interface IAddressLookupResponse {
  streetAddressResponse: any;
  pointAddressResponse: any;
  xStreetResponse: any;
  poiResponse: any;
}

const fetchAddressData = async (
  mapPoint: IMapPoint
): Promise<IAddressLookupResponse> => {
  let response = null;

  try {
    response = await axios
      .all([
        axios.get(`${LOCATOR_URL}/reverseGeocode`, {
          params: {
            location: mapPoint,
            featureTypes: "StreetAddress",
            f: "json",
          },
        }),
        axios.get(`${LOCATOR_URL}/reverseGeocode`, {
          params: {
            location: mapPoint,
            featureTypes: "PointAddress",
            f: "json",
          },
        }),
        axios.get(`${LOCATOR_URL}/reverseGeocode`, {
          params: {
            location: mapPoint,
            featureTypes: "StreetInt",
            f: "json",
          },
        }),
        axios.get(`${LOCATOR_URL}/reverseGeocode`, {
          params: {
            location: mapPoint,
            featureTypes: "POI",
            f: "json",
          },
        }),
      ])
      .then(
        axios.spread(
          (
            streetAddressResponse,
            pointAddressResponse,
            xStreetResponse,
            poiResponse
          ) => {
            return {
              streetAddressResponse,
              pointAddressResponse,
              xStreetResponse,
              poiResponse,
            };
          }
        )
      )
      .catch((errors: any) => {
        return errors;
      });
  } catch (error: any) {
    return error;
  }

  return response;
};

export default { fetchAddressData };
